export enum FoodType {
  MainDish = 1,
  PastriesAndSweets = 2,
  FoodStuffs = 3,
  Other = 4
}
